var _rect, _g, _rect2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 27,
    viewBox: "0 0 53 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 52,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_1305_10951)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1305_10951)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12,
    r: 9,
    fill: "#FFFEF7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1305_10951",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 52,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 52,
    height: 24,
    rx: 12,
    fill: "url(#paint1_linear_1305_10951)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1305_10951)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.95 14H40H34.2C32.5431 14 31.2 12.6569 31.2 11V10.4C31.2 8.74314 32.5431 7.4 34.2 7.4H34.61C35.1196 4.88954 37.3391 3 40 3C42.2557 3 44.1943 4.35802 45.0428 6.3011C47.1262 6.3504 48.8 8.05473 48.8 10.15C48.8 10.1944 48.7992 10.2387 48.7977 10.2828C48.7992 10.3217 48.8 10.3608 48.8 10.4V11C48.8 12.6569 47.4568 14 45.8 14H44.95Z",
    fill: "url(#paint2_linear_1305_10951)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9174 26.9437C37.239 28.3084 35.0734 29.0871 32.7424 28.9853C31.2422 28.9197 29.8422 28.4969 28.6208 27.8024C27.3602 29.1621 25.533 29.98 23.5355 29.8927C19.926 29.735 17.1276 26.681 17.2853 23.0714C17.443 19.4618 20.497 16.6635 24.1066 16.8212C24.2326 16.8267 24.3576 16.8358 24.4816 16.8482C25.7684 13.1122 29.393 10.504 33.5418 10.6852C37.6917 10.8665 41.0756 13.7822 42.0308 17.6176C42.155 17.6142 42.2802 17.6152 42.4062 17.6207C45.2939 17.7469 47.5325 20.1901 47.4064 23.0777C47.2802 25.9654 44.837 28.2041 41.9494 28.0779C40.7998 28.0277 39.753 27.6102 38.9174 26.9437Z",
    fill: "url(#paint3_linear_1305_10951)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1305_10951",
    x: 0,
    y: 1,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1305_10951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1305_10951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1305_10951",
    x1: 1,
    y1: 11.5,
    x2: 53,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106006,
    stopColor: "#5ED3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544473,
    stopColor: "#89A2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988128,
    stopColor: "#8750F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1305_10951",
    x1: 1,
    y1: 11.5,
    x2: 53,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00673288,
    stopColor: "#CD792B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52832,
    stopColor: "#A689FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89A2FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1305_10951",
    x1: 40,
    y1: 3,
    x2: 40,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1305_10951",
    x1: 32.8884,
    y1: 10.6567,
    x2: 32.0319,
    y2: 30.2639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.37d8b0b8ad174e565222b989e5e81a00.svg";
export { ForwardRef as ReactComponent };